export default class Menu {
	constructor(selector, options) {
		let defaultOptions = {
			burgerClass: '.burger',
			ulMenuListClass: 'ul.menu__list',
			menuMoreContainer: '.menu__more',
			menuMoreList: '.menu__more-list',
			headerClass: '.header',
			widthObjects: [],
			isMore: true,
			isMobile: false,
			breakpointMore: 768,
			burgerClick: () => { },
			burgerToggle: () => { },
		}
		this.options = Object.assign(defaultOptions, options);
		this.menu = document.querySelector(selector);
		this.burger = document.querySelector(defaultOptions.burgerClass);
		this.burgerClick();

		this.menuUl = this.menu.querySelector(defaultOptions.ulMenuListClass);
		this.more = this.menu.querySelector(defaultOptions.menuMoreContainer);
		this.moreMenu = this.menu.querySelector(defaultOptions.menuMoreList);
		this.parent = document.querySelector(defaultOptions.headerClass);
		//this.outher = document.querySelector('.header__brand');
		this.root = document.documentElement;
		this.moreWidth = getComputedStyle(this.root).getPropertyValue('--more-width');
		this.moreMargin = getComputedStyle(this.root).getPropertyValue('--more-margin');
		this.moreAllMargin = getComputedStyle(this.root).getPropertyValue('--all-margins');
		this.moreBurger = this.menu.querySelector('.menu__more-icon');
		this.widthObject = defaultOptions.widthObjects;
		this.mediaMinWidth = defaultOptions.breakpointMore;
		this.plusPx = 200;
		if (defaultOptions.isMore === true) {
			this.moreListMenu();
		}
		if (defaultOptions.isMobile) {
			this.mediaMinWidth = 320;
			this.isMobileClass();
		} else {
			this.isNotMobileClass();
		}
	}
	isMobileClass() {
		this.burger.remove();
		this.menu.querySelector('.menu__body').classList.add('menu__dynamic');
		this.moreBurger.classList.add('burger');
		this.moreBurger.classList.remove('menu__more-icon');
	}
	isNotMobileClass() {
		this.menu.querySelector('.menu__body').classList.add('menu__static');
	}
	burgerClick() {
		if (this.burger) {
			this.burger.addEventListener('click', function (e) {
				e.stopPropagation();
				this.burgerToggle();
			}.bind(this));
		}
		document.addEventListener('click', function (e) {
			e.stopPropagation();

			const target = e.target;
			const its_menu = target == this.menu || this.menu.contains(target);
			const its_btnMenu = target == this.burger;
			const menu_is_active = this.menu.classList.contains('menu--open');

			if (!its_menu && !its_btnMenu && menu_is_active) {
				this.burgerToggle();
			}

		}.bind(this));
	}
	burgerToggle() {
		if (this.burger) {

			this.menu.classList.toggle('menu--open');
			this.burger.classList.toggle('burger--active');
			document.body.classList.toggle('lock');
			if (this.menu.classList.contains('menu--open')) {
				const overlay = `<div class="overlay"></div>`;
				document.querySelector('body').insertAdjacentHTML('afterbegin', overlay);
			} else {
				document.querySelector('.overlay').remove();
			}
		}
	}

	moreListMenu() {
		let windowWidth = window.innerWidth;

		// функции только для десктопа
		if (window.innerWidth >= this.mediaMinWidth) {
			this.contract();
			this.checkActive();
		}

		window.addEventListener('resize', () => {
			if (window.innerWidth >= this.mediaMinWidth) {
				(window.innerWidth > windowWidth) ? this.expand() : this.contract();
				windowWidth = window.innerWidth;
				this.checkActive();
			}
		});

		if (this.moreBurger) {
			this.moreBurger.addEventListener('click', function (e) {
				e.stopPropagation();
				this.menuMoreToggle();
			}.bind(this))
		}
		document.addEventListener('click', function (e) {
			const target = e.target;
			const its_menu = target == this.moreMenu || this.moreMenu.contains(target);
			const its_btnMenu = target == this.burger;
			const menu_is_active = this.moreMenu.classList.contains('open');

			if (!its_menu && !its_btnMenu && menu_is_active) {
				this.menuMoreToggle();
			}
		}.bind(this));
	}


	contract() {
		let objectsWidth = 0;
		for (let i = 0; i < this.widthObject.length; i++) {
			objectsWidth += document.querySelector(this.widthObject[i]).offsetWidth;
		}

		let w = 0,
			outerWidth = this.parent.offsetWidth - (parseInt(this.moreWidth) + parseInt(this.moreMargin) + parseInt(this.moreAllMargin) + objectsWidth + 50);

		//let menuItems = this.menuUl.querySelectorAll('li');
		let menuItems = this.menuUl.children;

		for (let i = 1; i < menuItems.length; i++) {
			w += menuItems[i].offsetWidth;

			if (w > outerWidth) {
				//console.log(menuItems[i]);
				let nextElements = this.nextAll(menuItems[i - 1]);

				if (nextElements) {
					let nextReverse = nextElements.reverse();

					nextReverse.forEach(el => {
						el.remove();
						this.moreMenu.prepend(el);
					});
				}

				break;
			}
		}
	}
	nextAll(element) {
		const nextElements = [];
		//console.log(element);
		while (element.nextElementSibling) {

			nextElements.push(element.nextElementSibling);
			element = element.nextElementSibling;
		}

		return nextElements;
	}
	checkActive() {
		if (this.moreMenu.querySelectorAll('li').length) {
			this.more.classList.add('active');
		} else {
			this.more.classList.remove('active');
		}
	}

	expand() {
		let w = 0,
			outerWidth = this.parent.offsetWidth - (parseInt(this.moreWidth) + parseInt(this.moreMargin) + parseInt(this.moreAllMargin) + this.plusPx);

		let menuItems = this.menuUl.querySelectorAll('li');
		menuItems.forEach(el => {
			w += el.offsetWidth;
		});

		let moreMenuItems = this.moreMenu.querySelectorAll('li');
		for (let i = 0; i < moreMenuItems.length; i++) {
			w += moreMenuItems[i].offsetWidth;
			if (w > outerWidth) {
				let a = 0;

				while (a < i) {
					moreMenuItems[a].remove();
					this.menuUl.appendChild(moreMenuItems[a]);

					a++;
				}

				break;
			}
		}

		if (moreMenuItems.length > 0) {
			let lastOffset = moreMenuItems[moreMenuItems.length - 1].offsetWidth;

			if ((this.menuUl.offsetWidth + lastOffset) <= outerWidth) {
				moreMenuItems[moreMenuItems.length - 1].remove();
				this.menuUl.appendChild(moreMenuItems[moreMenuItems.length - 1]);
			}
		}
	}

	menuMoreToggle() {
		this.moreMenu.classList.toggle('open');
		this.moreBurger.classList.toggle('open');
	}
}

const fixedElement = {
	fixed: () => {
		let header = document.querySelector('.header');
		let body = document.body;
		let sticky = header.offsetTop;
		if (window.pageYOffset > sticky) {
			header.classList.add("fixed");
			body.classList.add("fixed");
			document.querySelector('.wrapper').style = 'padding-top:' + header.offsetHeight + 'px';
		} else {
			header.classList.remove("fixed");
			body.classList.remove("fixed");
			document.querySelector('.wrapper').style = '';
		}
	},
}


// Fixed
/*export default class Fixed {
	constructor(selector) {
		let defaultOptions = {
			headerClass: '.header',
		}
		this.header = document.querySelector(selector);
		this.body = document.body;
		this.sticky = this.header.offsetTop;
		if (window.pageYOffset > this.sticky) {
			this.addFixed();
		} else {
			this.removeFixed();
		}
	}
	addFixed() {
		this.header.classList.add("fixed");
		this.body.classList.add("fixed");
		document.querySelector('.wrapper').style = 'padding-top:' + this.offsetHeight + 'px';
	}
	removeFixed() {
		this.header.classList.remove("fixed");
		this.body.classList.remove("fixed");
		document.querySelector('.wrapper').style = '';
	}
}*/